import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { BlockVideo } from 'libs/editor/styles';

import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';
import { videoInfoToURL } from 'libs/editor/plugins/features/video';

@observer
export class VideoBlockNode extends React.Component {
  render() {
    const { node, isSelected, attributes } = this.props;
    const src = node.data.get('src');
    const site = node.data.get('site');

    if (site === 'unknown' || !src) {
      return (
        <span>
          [ <i>Unsupported iframe preview</i> ]
        </span>
      );
    }

    return (
      <BlockVideo selected={isSelected} {...attributes}>
        <iframe
          site={site}
          src={videoInfoToURL(src, site)}
          frameBorder='0'
          allowFullScreen
        />
      </BlockVideo>
    );
  }
}

VideoBlockNode.propTypes = {
  attributes: PropTypes.object,
  node: PropTypes.object,
  isSelected: PropTypes.bool,
};

export function VideoBlock() {
  return {
    button: {
      elementType: 'block',
      type: 'video-block',
      icon: 'camera',
    },
    plugins: [
      RenderNode('video-block', props => <VideoBlockNode {...props} />),
    ],
  };
}
